
import DetailSeparator from '../DetailSeparator';

export default DetailSeparator;
